// Validates a `?next=` redirect target so it can only ever send the browser
// to a same-origin path — never off-site. A plain `startsWith('/') &&
// !startsWith('//')` string check is bypassable: browsers normalize
// backslashes to forward slashes for http(s) URLs, so `/\evil.com` becomes
// `//evil.com` (protocol-relative) by the time `window.location.href` parses
// it, even though the literal string never started with `//`. Resolving
// against `URL` and comparing origins closes that gap.
export function getSafeNextPath(raw) {
  if (!raw) return null
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.includes('\\')) return null
  try {
    const resolved = new URL(raw, window.location.origin)
    if (resolved.origin !== window.location.origin) return null
    return resolved.pathname + resolved.search + resolved.hash
  } catch {
    return null
  }
}
